export default [
  {
    label: 'Drought Index',
    url: ''
  },
  {
    label: 'Growing Degree Days',
    url: ''
  },
  {
    label: 'Growing season report',
    url: ''
  },
  {
    label: 'Annual comparisons',
    url: ''
  },
  {
    label: 'Precipitation Patterns',
    url: ''
  }
]
